"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableBoardItem = exports.BoardItemInfo = exports.BoardItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const core_2 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const useTaskStateType_1 = require("../../hooks/useTaskStateType");
const StyledCard = (0, styled_components_1.default)(core_2.Card) `
  cursor: pointer;
  margin-bottom: 16px;
  min-height: min-content;
  &.dragging {
    opacity: 0.75;
  }
`;
const StyledListItem = (0, styled_components_1.default)(core_2.ListItem) `
  padding-left: 12px;
  padding-right: 12px;
  .check-icon svg {
    margin-left: auto;
  }
`;
const BoardItem = props => {
    const { task, isLoading, isSubTask, isDragging, onClick } = props, cardProps = __rest(props, ["task", "isLoading", "isSubTask", "isDragging", "onClick"]);
    const classes = ['task-card'];
    isDragging && classes.push('dragging');
    return (react_1.default.createElement(StyledCard, Object.assign({}, cardProps, { className: classes.join(' '), onClick: () => {
            if (!isSubTask) {
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }
        } }),
        isLoading && react_1.default.createElement(core_2.LinearProgress, null),
        !isSubTask && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_2.CardContent, null,
                react_1.default.createElement(core_2.Typography, { variant: 'body1' }, task.name)),
            react_1.default.createElement(core_2.Divider, null))),
        react_1.default.createElement(exports.BoardItemInfo, { task: task })));
};
exports.BoardItem = BoardItem;
exports.default = exports.BoardItem;
const BoardItemInfo = props => {
    const { task } = props;
    const user = task.user || task.modifiedBy;
    const isAssignee = !!task.user;
    const { isFinal } = (0, useTaskStateType_1.useTaskStateType)(task);
    const label = !user
        ? 'Not Assigned'
        : isAssignee
            ? 'Assigned To'
            : 'Last Modified By';
    return (react_1.default.createElement(StyledListItem, { dense: true, className: 'info' },
        user && (react_1.default.createElement(core_2.ListItemIcon, null, isAssignee ? react_1.default.createElement(icons_1.AccountCircle, null) : react_1.default.createElement(icons_1.Person, null))),
        react_1.default.createElement(core_2.ListItemText, { secondary: label, primary: user && `${user.firstName} ${user.lastName}` }),
        isFinal && (react_1.default.createElement(core_2.ListItemIcon, { className: 'check-icon' },
            react_1.default.createElement(icons_1.CheckCircle, { color: 'primary' })))));
};
exports.BoardItemInfo = BoardItemInfo;
const DraggableBoardItem = props => {
    const { task } = props;
    const { attributes, isDragging, listeners, setNodeRef } = (0, core_1.useDraggable)({
        id: task.id.toString()
    });
    return (react_1.default.createElement(exports.BoardItem, Object.assign({}, props, attributes, listeners, { innerRef: setNodeRef, isDragging: isDragging })));
};
exports.DraggableBoardItem = DraggableBoardItem;
//# sourceMappingURL=BoardItem.js.map